import React from 'react';
import { useTranslation } from 'react-i18next';

const MAP = {
  up: { es: 'Operativo', en: 'Operational', cls: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/25', dot: 'bg-emerald-400' },
  warn: { es: 'Advertencia', en: 'Warning', cls: 'bg-amber-500/10 text-amber-300 border-amber-500/25', dot: 'bg-amber-400 animate-warn-pulse' },
  down: { es: 'Caído', en: 'Down', cls: 'bg-red-500/10 text-red-300 border-red-500/25', dot: 'bg-red-400 animate-pulse' },
  maintenance: { es: 'Mantenimiento', en: 'Maintenance', cls: 'bg-sky-500/10 text-sky-300 border-sky-500/25', dot: 'bg-sky-400' },
  paused: { es: 'Pausado', en: 'Paused', cls: 'bg-slate-500/10 text-slate-300 border-slate-500/25', dot: 'bg-slate-400' },
  unknown: { es: 'Sin datos', en: 'Unknown', cls: 'bg-slate-500/10 text-slate-400 border-slate-500/20', dot: 'bg-slate-500' },
};

export default function StatusPill({ status, name }) {
  const { i18n } = useTranslation();
  const s = MAP[status] || MAP.unknown;
  const lang = i18n.language === 'en' ? 'en' : 'es';
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-xs font-medium border ${s.cls}`}
      data-testid={`status-pill-${name || 'svc'}-${status}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s[lang]}
    </span>
  );
}
